const WIDTH = 240

export const REFERENCING_FIELD = { width: WIDTH, height: 347 }
export const OWNER_FIELD = { width: WIDTH, height: 347 }
export const EMPTY_CONDITION = { width: WIDTH, height: 253 }
export const STATIC_WITHOUT_VALUE_SOURCE_SECTION = { width: WIDTH, height: 347 }

export const VALUE_SOURCE_RADIO_BUTTONS_WITHOUT_UOU_FILTERS = {
  STATIC: { width: WIDTH, height: 462 },
  DATASET: { width: WIDTH, height: 556 },
  STATIC_MULTI_REFERENCE: { width: WIDTH, height: 462 },
}

const extraPanelHeightWithSlug = 30

export const getValueSourceRadioButtonsWithSlug = () =>
  Object.keys(VALUE_SOURCE_RADIO_BUTTONS_WITHOUT_UOU_FILTERS).reduce(
    (dimensions, key) => {
      const values = VALUE_SOURCE_RADIO_BUTTONS_WITHOUT_UOU_FILTERS

      dimensions[key] = {
        width: values[key].width,
        height: values[key].height + extraPanelHeightWithSlug,
      }
      return dimensions
    },
    {
      SLUG: {
        width: WIDTH,
        height: 474,
      },
    },
  )
